import React from "react";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import NewsPaperendorDataTable from "./NewsPaperendorDataTable";
import { Helmet } from "react-helmet";
import { useAuth } from "../../../../Store/AuthContext";

export default function NewsPaperSchedule() {
  const { RendomTokenfetch } = useAuth();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "News Paper Schedule" }]} />

        <section className="user-dashboard">
          <div className="dashboard-outer">
            {/* ************Data Table Rows ************* */}

            {RendomTokenfetch && <NewsPaperendorDataTable />}
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
